module.exports = new __parcel__URL__("placeholder_woman.9c4841cd.png").toString();